export default __webpack_public_path__ + "static/media/frontend.e619e739.jpeg";